import {
  Button,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Flex,
  SimpleGrid,
  Text,
  Box,
  HStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FcApprove, FcDisapprove } from "react-icons/fc";
import { MdOutlineLogout, MdWarningAmber } from "react-icons/md";
import { RiFileEditLine, RiForbid2Line, RiQrScan2Line, RiLockPasswordLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { RiFileExcel2Line, RiSearch2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import CTable from "../../../components/Table/table";
import { adminPillSelectStyles } from "../../../components/Models/admin-modal-theme";
import ExportUsersButton from "./exportcsv";
import {
  openCreateStudent,
  openStudentReportModel,
  openUserQRCodeModel,
  openSuspendReasonModel,
} from "../../../modules/admin-modules/models/Actions";
import {
  approvedStudentsListRequest,
  approveStudentRequest,
  clearSessionRequest,
  deleteStudentRequest,
  rejectStudentRequest,
  restrictStudentRequest,
  studentsRequestsListRequest,
  resendPasswordRequest,
  addBulkStudentRequest,
} from "../../../modules/admin-modules/students/Actions";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";
import SuspendReasonModal from "./models/suspend-reason";

const CirclesStudentsTable = ({ setAdd, setSelectedData, searchTerm, setSearchTerm }) => {
  const approvedStudents = useSelector(
    (state) => state.students.approvedStudents
  );
  const pendeingStudents = useSelector(
    (state) => state.students.pendeingStudents
  );
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.students.isLoading);
  const count = useSelector((state) => state.students.count);
  const isRestrict = useSelector((state) => state.students.isRestrict);
  const isSuspend = useSelector((state) => state.students.isSuspend);

  const [offset, setPage] = useState(0);
  const [tab, setTab] = useState("approve");
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [studentGroupId, setStudentGroupId] = useState("");
  const [selected, setSelected] = useState({
    id: "",
  });
  const [suspendStudent, setSuspendStudent] = useState(null);
  const studentsList = tab === "approve" ? approvedStudents : pendeingStudents;
  const groups = useSelector((state) => state.groups.groups);
  const userData = useSelector((state) => state.user.userData);
  const isSuperAdmin = userData?.role?.[0]?.name === "Super Admin";

  useEffect(() => {
    dispatch(getAllGroupsRequest());
  }, [dispatch]);

  useEffect(() => {
    const timeId = setTimeout(() => {
      tab === "approve"
        ? dispatch(approvedStudentsListRequest(pageNumber + 1, searchTerm, studentGroupId))
        : dispatch(studentsRequestsListRequest(pageNumber + 1, searchTerm));
    }, 200);

    return () => {
      clearTimeout(timeId);
    };
  }, [pageNumber, searchTerm, tab, studentGroupId, dispatch]);

  // Function to format phone number for WhatsApp
  const formatPhoneForWhatsApp = (phone) => {
    if (!phone) return null;

    // Remove all spaces, dashes, brackets, and parentheses
    let cleaned = phone.toString().replace(/[\s\-\(\)\[\]]/g, '');

    // Check if it's an Egyptian number (starts with 012, 011, 010, 015)
    if (cleaned.match(/^(012|011|010|015)/)) {
      // Keep the 0 and add country code 2 before it
      cleaned = '2' + cleaned;
    } else {
      // Remove leading + or 00
      if (cleaned.startsWith('+')) {
        cleaned = cleaned.substring(1);
      } else if (cleaned.startsWith('00')) {
        cleaned = cleaned.substring(2);
      }
    }

    return cleaned;
  };

  const viewData = (data) => {
    // Find the original student data from studentsList to preserve original values (not JSX)
    const originalData = studentsList?.find((student) => student.id === data?.id);
    if (originalData) {
      setSelectedData(originalData);
      setSelected(originalData);
    } else {
      setSelectedData(data);
      setSelected(data);
    }
  };

  const PendingData = studentsList?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.group?.name,
      phone: (
        <HStack spacing={2} alignItems="center">
          <Text>{data?.phone}</Text>
          {data?.phone && (
            <IconButton
              as="a"
              href={`https://wa.me/${formatPhoneForWhatsApp(data?.phone)}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              size="sm"
              colorScheme="green"
              aria-label="WhatsApp"
              icon={<FaWhatsapp />}
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </HStack>
      ),
      approve: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="40px"
          icon={<FcApprove style={{ fontSize: "40px" }} />}
          onClick={() => dispatch(approveStudentRequest(data?.id))}
          isLoading={selected.id == data?.id ? isSuspend : false}
        />
      ),
      reject: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<FcDisapprove style={{ fontSize: "40px" }} />}
          onClick={() => dispatch(rejectStudentRequest(data?.id))}
          isLoading={selected.id == data?.id ? isRestrict : false}
        />
      ),
    };
  });
  const pendingColumns = [
    {
      Header: "Student ID",
      accessor: "index",
    },
    {
      Header: "Student Name",
      accessor: "student_name",
    },
    {
      Header: "Phone",
      accessor: "phone",
    },
    {
      Header: "Group",
      accessor: "group_name",
    },
    {
      Header: "Approve",
      accessor: "approve",
    },
    {
      Header: "Reject",
      accessor: "reject",
    },
  ];

  const Data = studentsList?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.group?.name,
      phone: (
        <HStack spacing={2} alignItems="center">
          <Text>{data?.phone}</Text>
          {data?.phone && (
            <IconButton
              as="a"
              href={`https://wa.me/${formatPhoneForWhatsApp(data?.phone)}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              size="sm"
              colorScheme="green"
              aria-label="WhatsApp"
              icon={<FaWhatsapp />}
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </HStack>
      ),
      parent_phone: (
        <HStack spacing={2} alignItems="center">
          <Text>{data?.parent_phone}</Text>
          {data?.parent_phone && (
            <IconButton
              as="a"
              href={`https://wa.me/${formatPhoneForWhatsApp(data?.parent_phone)}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              size="sm"
              colorScheme="green"
              aria-label="WhatsApp"
              icon={<FaWhatsapp />}
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </HStack>
      ),
      code: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiQrScan2Line />}
          onClick={() => dispatch(openUserQRCodeModel())}
        />
      ),

      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={
            <MdWarningAmber
              color={data?.deleted_at == null ? "red" : "green"}
            />
          }
          onClick={() => {
            if (data?.deleted_at != null) {
              dispatch(deleteStudentRequest(data?.id));
            } else {
              setSuspendStudent(data);
              dispatch(openSuspendReasonModel());
            }
          }}
          isLoading={selected.id == data?.id ? isSuspend : false}
        />
      ),
      restrict: (
        <IconButton
          variant="outline"
          color="gray.600"
          border="0"
          aria-label="Call Sage"
          fontSize="20px"
          isLoading={selected.id == data?.id ? isRestrict : false}
          icon={<RiForbid2Line color={data?.restrict == 0 ? "red" : "green"} />}
          onClick={() => {
            const formData = new FormData();
            formData.append("_method", "PUT");
            data?.restrict == 0
              ? formData.append("restrict", 0)
              : formData.append("restrict", 1);
            dispatch(
              restrictStudentRequest({
                id: data?.id,
                formData: formData,
              })
            );
          }}
        />
      ),
      clearSession: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<MdOutlineLogout />}
          onClick={() => dispatch(clearSessionRequest(data?.id))}
        />
      ),
      resendPassword: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Resend Password"
          fontSize="20px"
          icon={<RiLockPasswordLine />}
          onClick={() => {
            setSelected({ id: data?.id });
            dispatch(resendPasswordRequest(data?.id));
          }}
          isLoading={selected.id === data?.id ? isLoading : false}
        />
      ),
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openCreateStudent());
          }}
        />
      ),
      subject_name: data?.subject?.name,
    };
  });
  const columns = [
    {
      Header: "Student ID",
      accessor: "index",
    },
    {
      Header: "Student Name",
      accessor: "student_name",
    },
    {
      Header: "Asquera code",
      accessor: "user_name",
    },
    ...(isSuperAdmin
      ? [
        {
          Header: "Subject",
          accessor: "subject_name",
        },
      ]
      : []),
    {
      Header: "Group",
      accessor: "group_name",
    },
    {
      Header: "QR Code",
      accessor: "code",
    },
    {
      Header: "Phone",
      accessor: "phone",
    },
    {
      Header: "Parent Phone",
      accessor: "parent_phone",
    },
    {
      Header: "Stop",
      accessor: "delete",
    },
    {
      Header: " Clear Session",
      accessor: "clearSession",
    },
    {
      Header: "Restrict",
      accessor: "restrict",
    },
    {
      Header: "Resend Password",
      accessor: "resendPassword",
    },
    {
      Header: "Edit",
      accessor: "edit",
    },

  ];

  const actions = (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={<RiFileEditLine />}
        size="sm"
        fontSize="20px"
        variant="outline"
        border="none"
      />
      <MenuList>
        <MenuItem
          onClick={() => {
            setAdd(false);
            dispatch(openCreateStudent());
          }}
        >
          تعديل
        </MenuItem>
      </MenuList>
    </Menu>
  );

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const colourStyles = adminPillSelectStyles({ menuZIndex: 20 });

  return (
    <>
      <Box px={{ base: 4, md: 8 }} pt={6} pb={10} w="100%">
        <Flex
          align={{ base: "flex-start", md: "flex-end" }}
          justify="space-between"
          gap={6}
          flexDir={{ base: "column", md: "row" }}
          mb={8}
        >
          <Box>
            <Text
              fontSize={{ base: "32px", md: "54px" }}
              fontWeight="800"
              color="#6A1E1E"
              fontFamily="'Amiri', 'Tajawal', sans-serif"
              lineHeight="1"
            >
              Student List
            </Text>
            <Text mt={3} color="rgba(30, 27, 23, 0.6)" fontSize="sm">
              Manage academic records and personal data for institution students
            </Text>
          </Box>

          <Flex gap={3} align="center" flexWrap="wrap">
            <Button
              borderColor="#6A1E1E"
              border="1px solid"
              borderRadius="full"
              leftIcon={<RiFileExcel2Line />}
              color="#6A1E1E"
              bg="rgba(255,255,255,0.75)"
              _hover={{ bg: "rgba(233, 226, 219, 0.6)" }}
              position="relative"
            >
              <Text>Add Students in Bulk</Text>
              <Input
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  const formData = new FormData();
                  formData.append("student_bulk", file);
                  dispatch(addBulkStudentRequest(formData));
                  e.target.value = "";
                }}
                type="file"
                opacity="0"
                position="absolute"
                w="100%"
                h="100%"
                left="0"
                top="0"
                cursor="pointer"
              />
            </Button>

            <Box
              sx={{
                "& button": {
                  borderRadius: "9999px",
                  border: "1px solid #D8CEC3",
                  background: "rgba(255,255,255,0.75)",
                  color: "#4A0F1F",
                  fontWeight: 700,
                },
                "& button:hover": {
                  background: "rgba(233, 226, 219, 0.6)",
                },
              }}
            >
              <ExportUsersButton />
            </Box>

            <Button
              borderRadius="full"
              bg="#6A1E1E"
              color="#FAF2EB"
              px={8}
              py={6}
              fontWeight="800"
              _hover={{ bg: "#4A0F1F" }}
              onClick={() => {
                setAdd(true);
                dispatch(openCreateStudent());
              }}
            >
              + Add New Student
            </Button>
          </Flex>
        </Flex>

        <Box mt={6} mb={6}>
          <InputGroup maxW="520px">
            <InputLeftElement pointerEvents="none">
              <RiSearch2Fill color="rgba(106, 30, 30, 0.5)" fontSize="18px" />
            </InputLeftElement>
            <Input
              placeholder="Search for student..."
              borderRadius="full"
              border="1px solid"
              borderColor="#D8CEC3"
              bg="transparent"
              _focus={{ borderColor: "#6A1E1E" }}
              onChange={(e) => setSearchTerm?.(e.target.value)}
            />
          </InputGroup>
        </Box>

        <Flex
          align="center"
          gap={3}
          mb={4}
          flexWrap="wrap"
          justify="flex-start"
        >
          <Button
            size="sm"
            borderRadius="full"
            bg={tab === "approve" ? "#6A1E1E" : "transparent"}
            color={tab === "approve" ? "white" : "#6A1E1E"}
            border="1px solid"
            borderColor="#D8CEC3"
            _hover={{ bg: tab === "approve" ? "#4A0F1F" : "rgba(216, 206, 195, 0.35)" }}
            onClick={() => setTab("approve")}
          >
            Approved
          </Button>
          <Button
            size="sm"
            borderRadius="full"
            bg={tab === "pending" ? "#6A1E1E" : "transparent"}
            color={tab === "pending" ? "white" : "#6A1E1E"}
            border="1px solid"
            borderColor="#D8CEC3"
            _hover={{ bg: tab === "pending" ? "#4A0F1F" : "rgba(216, 206, 195, 0.35)" }}
            onClick={() => setTab("pending")}
          >
            Pending
          </Button>

          {tab === "approve" && (
            <Box minW={{ base: "260px", md: "320px" }}>
              <Select
                options={groupsOptions}
                isMulti={false}
                isClearable
                onChange={(data) => {
                  setStudentGroupId(data?.value || "");
                }}
                styles={colourStyles}
                placeholder="Select Group"
              />
            </Box>
          )}
        </Flex>

        <Box
          bg="rgba(255,255,255,0.9)"
          border="1px solid"
          borderColor="#D8CEC3"
          borderRadius="16px"
          overflow="hidden"
          boxShadow="sm"
        >
          <CTable
            selectedData={viewData}
            Columns={tab === "approve" ? columns : pendingColumns}
            Data={tab === "approve" ? Data : PendingData}
            Actions={actions}
            setPage={setPage}
            currentpage={pageNumber}
            setPageNumber={setPageNumber}
            isLoading={isLoading}
            totalPage={Math.ceil(count / 50)}
            wrapperProps={{ maxH: "unset", overflow: "auto" }}
            tableProps={{ bg: "transparent", borderRadius: "0" }}
            theadProps={{ bg: "#D8CEC3" }}
          />
        </Box>
      </Box>

      {/* Suspend Reason Modal */}
      <SuspendReasonModal studentData={suspendStudent} />
    </>
  );
};

export default CirclesStudentsTable;
